import React from 'react';
import styles from './ErrorMessage.module.scss';

interface Props {
  message: string;
}

export const ErrorMessage = ({ message }: Props) => (
  <div className={styles.error}>
    <div className={styles.errorIcon}>⚠️</div>
    <div className={styles.errorText}>{message}</div>
  </div>
); 